export const NO_TERRITORY_ACTIVE_SELECTION = {
  id: 'USE_MAP_NO_TERRITORY',
  name: 'Map Without Territory',
};
